import { action } from "typesafe-actions";
import { TransactionTypes } from "./types";
import { Currency, DataStream, TransactionHistory, VASTransactionRequest, VASTransactionDashboardResponse, CollectionSummaryRequest, CollectionDashboardResponse } from "../../interfaces";

export const getTransactionsRequest = (payload: any) =>
  action(TransactionTypes.GET_TRANSACTIONS_REQUEST, payload);

export const getTransactionsSuccess = (data: TransactionHistory) =>
  action(TransactionTypes.GET_TRANSACTIONS_SUCCESS, data);

export const getTransactionsFailure = (error: any) =>
  action(TransactionTypes.GET_TRANSACTIONS_FAILURE, error);

export const getCurrencies = () => action(TransactionTypes.GET_CURRENCIES);

export const getCurrenciesSuccess = (data: Currency[]) =>
  action(TransactionTypes.GET_CURRENCIES_SUCCESS, data);

export const getCurrenciesFailure = (error: any) =>
  action(TransactionTypes.GET_CURRENCIES_FAILURE, error);

export const exportTranxRequest = (payload: any) =>
  action(TransactionTypes.EXPORT_TRANSACTIONS_REQUEST, payload);

export const exportTranxSuccess = (data: DataStream) =>
  action(TransactionTypes.EXPORT_TRANSACTIONS_SUCCESS, data);

export const exportTranxFailure = (error: any) =>
  action(TransactionTypes.EXPORT_TRANSACTIONS_FAILURE, error);

export const downloadReceiptRequest = (transactionId: number) =>
  action(TransactionTypes.DOWNLOAD_RECEIPT_REQUEST, transactionId);

export const downloadReceiptSuccess = (data: DataStream) =>
  action(TransactionTypes.DOWNLOAD_RECEIPT_SUCCESS, data);

export const downloadReceiptFailure = (error: any) =>
  action(TransactionTypes.DOWNLOAD_RECEIPT_FAILURE, error);

export const clearVAS = () => action(TransactionTypes.CLEAR_VAS);

export const getVASDashboardRequest = (payload: VASTransactionRequest) =>
  action(TransactionTypes.GET_VAS_DASHBOARD_REQUEST, payload);

export const getVASDashboardSuccess = (data: VASTransactionDashboardResponse) =>
  action(TransactionTypes.GET_VAS_DASHBOARD_SUCCESS, data);

export const getVASDashboardFailure = (error: any) =>
  action(TransactionTypes.GET_VAS_DASHBOARD_FAILURE, error);

export const getCollectionDashboardRequest = (payload: CollectionSummaryRequest) =>
  action(TransactionTypes.GET_COLLECTION_DASHBOARD_REQUEST, payload);

export const getCollectionDashboardSuccess = (data: CollectionDashboardResponse) =>
  action(TransactionTypes.GET_COLLECTION_DASHBOARD_SUCCESS, data);

export const getCollectionDashboardFailure = (error: any) =>
  action(TransactionTypes.GET_COLLECTION_DASHBOARD_FAILURE, error);
